var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ToolBar',{class:_vm.currentPath}),_c('div',{staticClass:"main-page"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }